import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { UsoVehiculoModel } from '../../models/uso-vehiculo.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsoVehiculoService extends BaseService<UsoVehiculoModel> {

  tipo: string;
  urlBase: string;
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.tipo = 'Uso vehiculo';
    this.urlBase = `${environment.baseApi}${environment.endPoints.maestras.base_maestra}${environment.endPoints.maestras.usoVehiculo}`;
   }
}
